export const ModalStates = {
  Review: 'review',
  Merge: 'merge',
  ConfirmMerge: 'confirmMerge',
  Edit: 'edit',
  ConfirmEdit: 'confirmEdit',
  ResultMessage: 'resultMessage',
}